import React from 'react';
import { LargeBold, SmallBold, SmallRegular, Point } from './GettingStarted';
import { Box } from '@mui/material';
import ScoreCard6 from '../../assets/icons/ScoreCard6';
import ScoreCard1 from '../../assets/icons/ScoreCard1';
import ScoreCard2 from '../../assets/icons/ScoreCard2';
import ScoreCard3 from '../../assets/icons/ScoreCard3';
import ScoreCard4 from '../../assets/icons/ScoreCard4';
import ScoreCard5 from '../../assets/icons/ScoreCard5';

const JobfactorScore = () => {
    return (
        <Box>
            <Box mb="45px">
                <Box mb="25px">
                    <LargeBold>
                        Jobfactor Score guide: Understanding the different
                        levels of Jobfactor score
                    </LargeBold>
                </Box>
                <SmallRegular>
                    Welcome to the heart of Jobfactor – your Jobfactor Score.
                    This dynamic metric reflects your professional prowess and
                    influences how employers perceive your skills and
                    achievements. Let's embark on a journey through the various
                    Jobfactor Score levels.
                </SmallRegular>
            </Box>
            <Box mb="45px">
                <Box mb="32px">
                    <Box mb="25px">
                        <SmallBold>
                            1. Incomplete Profile (Basic Score)
                        </SmallBold>
                    </Box>
                    <Box display="flex" alignItems="flex-start" gap="40px">
                        <Box display={{ xs: 'none', md: 'block' }}>
                            <ScoreCard1 />
                        </Box>

                        <Box>
                            <Box
                                display={{ xs: 'block', md: 'none' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    <Box
                                        display="flex"
                                        gap="20px"
                                        alignItems="center"
                                    >
                                        <Box
                                            display={{
                                                xs: 'inline',
                                                md: 'none'
                                            }}
                                        >
                                            <ScoreCard1
                                                width="93px"
                                                height="125px"
                                            />
                                        </Box>
                                        <SmallRegular>
                                            Individuals at this Jobfactor Score
                                            level have Complete Profile, at
                                            least 10 Connections, and no
                                            activities or ratings on skills
                                        </SmallRegular>{' '}
                                    </Box>
                                    and limited to no education and work
                                    experience on record.
                                </SmallRegular>
                            </Box>
                            <Box
                                display={{ xs: 'none', md: 'block' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    Individuals at this Jobfactor Score level
                                    have Complete Profile, at least 10
                                    Connections, and no activities or ratings on
                                    skills and limited to no education and work
                                    experience on record.
                                </SmallRegular>
                            </Box>
                            <SmallRegular>Action Steps:</SmallRegular>
                            <Point>
                                Complete Your Profile: Fill in all the essential
                                details to enhance your visibility.
                            </Point>
                            <Point>
                                Connect with Peers: Establish meaningful
                                connections within your industry.
                            </Point>
                        </Box>
                    </Box>
                </Box>
                <Box mb="32px">
                    <Box mb="25px">
                        <SmallBold>
                            2. Beginner Level (Score Range: 251 to 400)
                        </SmallBold>
                    </Box>
                    <Box display="flex" alignItems="flex-start" gap="40px">
                        <Box display={{ xs: 'none', md: 'block' }}>
                            <ScoreCard2 />
                        </Box>
                        <Box>
                            <Box
                                display={{ xs: 'block', md: 'none' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    <Box
                                        display="flex"
                                        gap="20px"
                                        alignItems="center"
                                    >
                                        <Box
                                            display={{
                                                xs: 'inline',
                                                md: 'none'
                                            }}
                                        >
                                            <ScoreCard2
                                                width="93px"
                                                height="125px"
                                            />
                                        </Box>
                                        <SmallRegular>
                                            Individuals at this Jobfactor Score
                                            level typically have Complete
                                            Profile, at least 10 Connections,
                                            some academic record with
                                        </SmallRegular>
                                    </Box>
                                    limited practical experience and may still
                                    be in the early stages of learning as
                                    demonstrated by activities on the platform
                                    and peer reviews.
                                </SmallRegular>
                            </Box>
                            <Box
                                display={{ xs: 'none', md: 'block' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    Individuals at this Jobfactor Score level
                                    typically have Complete Profile, at least 10
                                    Connections, some academic record with
                                    limited practical experience and may still
                                    be in the early stages of learning as
                                    demonstrated by activities on the platform
                                    and peer reviews.
                                </SmallRegular>
                            </Box>
                            <SmallRegular>Action Steps:</SmallRegular>
                            <Point>
                                Share Achievements: Highlight your milestones
                                and accomplishments.
                            </Point>
                            <Point>
                                Request Peer Reviews: Invite colleagues to rate
                                your demonstrated skills.
                            </Point>
                        </Box>
                    </Box>
                </Box>
                <Box mb="32px">
                    <Box mb="25px">
                        <SmallBold>
                            3. Experienced Level (Score Range: 401 to 500)
                        </SmallBold>
                    </Box>
                    <Box display="flex" alignItems="flex-start" gap="40px">
                        <Box display={{ xs: 'none', md: 'block' }}>
                            <ScoreCard3 />
                        </Box>
                        <Box>
                            <Box
                                display={{ xs: 'block', md: 'none' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    <Box
                                        display="flex"
                                        gap="20px"
                                        alignItems="center"
                                    >
                                        <Box
                                            display={{
                                                xs: 'inline',
                                                md: 'none'
                                            }}
                                        >
                                            <ScoreCard3
                                                width="93px"
                                                height="125px"
                                            />
                                        </Box>
                                        <SmallRegular>
                                            Individuals at this Jobfactor Score
                                            level typically have Complete
                                            Profile, at least 10 Connections,
                                            They will have good academic record
                                            with
                                        </SmallRegular>
                                    </Box>
                                    adequate proficiency through hands-on
                                    experience and can perform tasks confidently
                                    as demonstrated by activities on the
                                    platform and peer reviews.
                                </SmallRegular>
                            </Box>
                            <Box
                                display={{ xs: 'none', md: 'block' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    Individuals at this Jobfactor Score level
                                    typically have Complete Profile, at least 10
                                    Connections, They will have good academic
                                    record with adequate proficiency through
                                    hands-on experience and can perform tasks
                                    confidently as demonstrated by activities on
                                    the platform and peer reviews.
                                </SmallRegular>
                            </Box>
                            <SmallRegular>Action Steps:</SmallRegular>
                            <Point>
                                Actively Participate: Engage in discussions,
                                forums, and share insights to boost your
                                visibility.
                            </Point>
                            <Point>
                                Consistent Networking: Continue building a
                                robust network.
                            </Point>
                        </Box>
                    </Box>
                </Box>
                <Box mb="32px">
                    <Box mb="25px">
                        <SmallBold>
                            4. Advanced Level (Score Range: 501 to 600)
                        </SmallBold>
                    </Box>
                    <Box display="flex" alignItems="flex-start" gap="40px">
                        <Box display={{ xs: 'none', md: 'block' }}>
                            <ScoreCard4 />
                        </Box>
                        <Box>
                            <Box
                                display={{ xs: 'block', md: 'none' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    <Box
                                        display="flex"
                                        gap="20px"
                                        alignItems="center"
                                    >
                                        <Box
                                            display={{
                                                xs: 'inline',
                                                md: 'none'
                                            }}
                                        >
                                            <ScoreCard4
                                                width="93px"
                                                height="125px"
                                            />
                                        </Box>
                                        <SmallRegular>
                                            Individuals at this Jobfactor Score
                                            level typically have Complete
                                            Profile, at least 10 Connections,
                                            They will have good academic record.
                                        </SmallRegular>
                                    </Box>
                                    Advanced users have reached a higher level
                                    of skill mastery and can handle complex
                                    tasks with competence as demonstrated by
                                    activities on the platform and peer reviews.
                                    Individuals in this category are capable of
                                    tackling challenging projects,
                                    troubleshooting effectively, and often seek
                                    innovative solutions.
                                </SmallRegular>
                            </Box>
                            <Box
                                display={{ xs: 'none', md: 'block' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    Individuals at this Jobfactor Score level
                                    typically have Complete Profile, at least 10
                                    Connections, They will have good academic
                                    record. Advanced users have reached a higher
                                    level of skill mastery and can handle
                                    complex tasks with competence as
                                    demonstrated by activities on the platform
                                    and peer reviews. Individuals in this
                                    category are capable of tackling challenging
                                    projects, troubleshooting effectively, and
                                    often seek innovative solutions.
                                </SmallRegular>
                            </Box>
                            <SmallRegular>Action Steps:</SmallRegular>
                            <Point>
                                Tackle Complex Projects: Demonstrate your
                                ability to handle challenging tasks.
                            </Point>
                            <Point>
                                Innovative Solutions: Showcase your
                                problem-solving skills and innovation.
                            </Point>
                        </Box>
                    </Box>
                </Box>
                <Box mb="32px">
                    <Box mb="25px">
                        <SmallBold>
                            5. Expert Level (Score Range: 601 to 700)
                        </SmallBold>
                    </Box>
                    <Box display="flex" alignItems="flex-start" gap="40px">
                        <Box display={{ xs: 'none', md: 'block' }}>
                            <ScoreCard5 />
                        </Box>
                        <Box>
                            <Box
                                display={{ xs: 'block', md: 'none' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    <Box
                                        display="flex"
                                        gap="20px"
                                        alignItems="center"
                                    >
                                        <Box
                                            display={{
                                                xs: 'inline',
                                                md: 'none'
                                            }}
                                        >
                                            <ScoreCard5
                                                width="93px"
                                                height="125px"
                                            />
                                        </Box>
                                        <SmallRegular>
                                            Individuals at this Jobfactor Score
                                            level typically have Complete
                                            Profile, at least 10 Connections,
                                            They will have extensive academic
                                            work
                                        </SmallRegular>
                                    </Box>
                                    history. An expert is someone who has
                                    achieved an exceptional level of skill
                                    mastery and is recognized as a subject
                                    matter authority. As demonstrated by
                                    activities on the platform and peer reviews.
                                    Additionally, Users in this category have
                                    extensive experience, often contributing to
                                    the field through thought leadership,
                                    publications, or mentorship.
                                </SmallRegular>
                            </Box>
                            <Box
                                display={{ xs: 'none', md: 'block' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    Individuals at this Jobfactor Score level
                                    typically have Complete Profile, at least 10
                                    Connections, They will have extensive
                                    academic work history. An expert is someone
                                    who has achieved an exceptional level of
                                    skill mastery and is recognized as a subject
                                    matter authority. As demonstrated by
                                    activities on the platform and peer reviews.
                                    Additionally, Users in this category have
                                    extensive experience, often contributing to
                                    the field through thought leadership,
                                    publications, or mentorship.
                                </SmallRegular>
                            </Box>
                            <SmallRegular>Action Steps:</SmallRegular>
                            <Point>
                                Mentorship and Leadership: Contribute to the
                                field through mentorship, publications, or
                                thought leadership.
                            </Point>
                            <Point>
                                Continuous Learning: Stay at the forefront of
                                industry trends.
                            </Point>
                        </Box>
                    </Box>
                </Box>
                <Box mb="32px">
                    <Box mb="25px">
                        <SmallBold>
                            6. Thought Leader Level (Score Range: 701 to 800)
                        </SmallBold>
                    </Box>
                    <Box display="flex" alignItems="flex-start" gap="40px">
                        <Box display={{ xs: 'none', md: 'block' }}>
                            <ScoreCard6 />
                        </Box>
                        <Box>
                            <Box
                                display={{ xs: 'block', md: 'none' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    <Box
                                        display="flex"
                                        gap="20px"
                                        alignItems="center"
                                    >
                                        <Box
                                            display={{
                                                xs: 'inline',
                                                md: 'none'
                                            }}
                                        >
                                            <ScoreCard1
                                                width="93px"
                                                height="125px"
                                            />
                                        </Box>
                                        <SmallRegular>
                                            Individuals at this Jobfactor Score
                                            level typically have Complete
                                            Profile, at least 10 Connections,
                                            They will have exceptional academic
                                            and
                                        </SmallRegular>
                                    </Box>
                                    work history over an extended period.
                                    Thought leaders are at the forefront of
                                    their industry, shaping trends, and
                                    influencing others as demonstrated by
                                    activities on the platform and peer reviews.
                                    Additionally, Individuals in this category
                                    are visionaries, contributing original ideas
                                    and inspiring others through their
                                    expertise.
                                </SmallRegular>
                            </Box>
                            <Box
                                display={{ xs: 'none', md: 'block' }}
                                mb="25px"
                            >
                                <SmallRegular>
                                    Individuals at this Jobfactor Score level
                                    typically have Complete Profile, at least 10
                                    Connections, They will have exceptional
                                    academic and work history over an extended
                                    period. Thought leaders are at the forefront
                                    of their industry, shaping trends, and
                                    influencing others as demonstrated by
                                    activities on the platform and peer reviews.
                                    Additionally, Individuals in this category
                                    are visionaries, contributing original ideas
                                    and inspiring others through their
                                    expertise.
                                </SmallRegular>
                            </Box>
                            <SmallRegular>Action Steps:</SmallRegular>
                            <Point>
                                Original Contributions: Contribute original
                                ideas and insights to the professional
                                community.
                            </Point>
                            <Point>
                                Visionary Leadership: Lead by example,
                                influencing positive changes in your industry.
                            </Point>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <SmallRegular>
                Understanding your Jobfactor Score progression empowers you to
                take targeted actions, enhancing your professional standing and
                increasing your visibility within the Jobfactor community.
                Strive for continuous improvement, and let your Jobfactor Score
                be a testament to your evolving expertise and success. Elevate
                your career journey with Jobfactor!
            </SmallRegular>
        </Box>
    );
};

export default JobfactorScore;
